import quote from 'assets/quote-icon.png';
import { useRef } from 'react';
import './aboutme.css';

const AboutMe = () => {
  const isNonMobile = window.matchMedia('(min-width: 1220px)').matches;
  const isNonMediumabove = window.matchMedia('(min-width: 581px)').matches;

  const cardRef = useRef(null);

  const generateTranslate = (el, e, value) => {
    el.style.transform = `translate(${e.clientX * value}px, ${
      e.clientY * value
    }px)`;
  };

  const cumulativeOffset = (element) => {
    let top = 0,
      left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return {
      top: top,
      left: left,
    };
  };

  const handleMouseMove = (event) => {
    const e = event || window.event;
    const x =
      ((e.pageX - cumulativeOffset(cardRef.current).left - 350 / 2) * -1) / 100;
    const y =
      ((e.pageY - cumulativeOffset(cardRef.current).top - 350 / 2) * -1) / 100;

    const matrix = [
      [1, 0, 0, -x * 0.00005],
      [0, 1, 0, -y * 0.00005],
      [0, 0, 1, 1],
      [0, 0, 0, 1],
    ];

    generateTranslate(
      cardRef.current.querySelector('.card__smallCircle'),
      e,
      0.03
    );
    generateTranslate(
      cardRef.current.querySelector('.card__thankyou'),
      e,
      0.03
    );
    generateTranslate(
      cardRef.current.querySelector('.card__orangeShine'),
      e,
      0.09
    );
    generateTranslate(cardRef.current.querySelector('.card__circle'), e, 0.05);
    generateTranslate(cardRef.current.querySelector('.card__year'), e, 0.03);
    generateTranslate(
      cardRef.current.querySelector('.card__cometOuter'),
      e,
      0.05
    );

    cardRef.current.style.transform = `matrix3d(${matrix.toString()})`;
  };
  return (
    <>
      <section
        className='aboutme-container '
        onMouseMove={handleMouseMove}
        data-aos='fade-up'
      >
        <div className='display-flex-between' data-aos='fade-right'>
          <div className='aboutme-left'>
            <div style={{ fontStyle: 'italic' }}>
              <h1>
                <span>
                  <div className='graphictick-container'>
                    <img
                      className='graphictick'
                      src={quote}
                      alt='double-quotes'
                    />
                  </div>
                </span>
                <br />
                Micheal is AMAZING! <br />
              </h1>
              <p>
                {' '}
                If you have any doubt about hiring him, ask me – I am really
                impressed by this guy!. <br />
                <br />I may be a bit biased, but seriously,{' '}
                <span className='whitening-cream'>
                  my child is the developer out there!{' '}
                </span>
                <br />
              </p>
              <p>
                He's got more coding skills than I have baking recipes (and
                that's a lot)!
              </p>
              <div className='mom-icon-flex'>
                <div>
                  <img src='assets/mom.png' alt='mom-icon' />
                </div>
                <div className='hover-underline-animation'>
                  <h4> - My Mom !</h4>
                </div>{' '}
              </div>
            </div>
          </div>
          {isNonMediumabove && (
            <>
              <div class='wrapper-3d'>
                {' '}
                <div ref={cardRef} className='card-3d'>
                  <div className='card__year'>
                    MOM
                    <br />
                    {/* 16 */}
                  </div>
                  <div className='card__cometOuter'>
                    <div className='card__comet'></div>
                    <div className='card__comet card__comet--second'></div>
                  </div>
                  <div className='card__circle'></div>
                  <div className='card__smallCircle'></div>
                  <div className='card__orangeShine'></div>
                  <div className='card__greenShine'></div>
                  <div className='card__thankyou'>
                    Thank
                    <br />
                    you{' '}
                  </div>
                  <div className='card__outer-year'>
                    <span>✣</span>
                    <span>❃</span>
                    <span>✨</span>
                    <span>✍️</span>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* {isNonMobile && (
            <div className='aboutme-right' data-aos='fade-left'>
              <div className='about-me-right-container'>
                <div
                  className='anime-grad hover-underline-animation'
                  style={{ fontSize: '2rem', marginTop: '0px' }}
                  data-aos='fade-up'
                >
                  <h3>Mom's Insight</h3>
                </div>

                <div class='center selftaught'>
                  <a href='#home'>
                    <span data-attr='Genius'>Genius</span>
                    <span data-attr='one'></span>
                  </a>
                </div>
                <div class='center selftaught'>
                  <a href='#home'>
                    <span data-attr='Trust'>Trust</span>
                    <span data-attr='worthy'></span>
                  </a>
                </div>
                <div class='center selftaught'>
                  <a href='#home'>
                    <span data-attr='Passionate'>Passionate</span>
                    <span data-attr='one'></span>
                  </a>
                </div>
              </div>
            </div>
          )} */}
        </div>
      </section>
    </>
  );
};

export default AboutMe;
